import React, { useEffect, useRef } from 'react';
import styles from './GraphVisual.module.css';

const GraphVisual = ({ data, label }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;

    // Clear canvas
    ctx.clearRect(0, 0, width, height);

    // Draw grid
    ctx.strokeStyle = 'rgba(0, 123, 255, 0.1)';
    ctx.lineWidth = 1;
    for (let i = 0; i <= 10; i++) {
      const y = (height / 10) * i;
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(width, y);
      ctx.stroke();
    }

    // Draw line graph
    if (data && data.length > 0) {
      ctx.strokeStyle = '#00BFFF';
      ctx.lineWidth = 3;
      ctx.beginPath();
      
      const stepX = width / (data.length - 1);
      const maxValue = Math.max(...data);
      
      data.forEach((value, index) => {
        const x = index * stepX;
        const y = height - (value / maxValue) * height * 0.8 - height * 0.1;
        
        if (index === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      });
      
      ctx.stroke();

      // Draw gradient fill
      const gradient = ctx.createLinearGradient(0, 0, 0, height);
      gradient.addColorStop(0, 'rgba(0, 191, 255, 0.3)');
      gradient.addColorStop(1, 'rgba(0, 191, 255, 0)');
      
      ctx.fillStyle = gradient;
      ctx.lineTo(width, height);
      ctx.lineTo(0, height);
      ctx.closePath();
      ctx.fill();

      // Draw points
      data.forEach((value, index) => {
        const x = index * stepX;
        const y = height - (value / maxValue) * height * 0.8 - height * 0.1;
        
        ctx.fillStyle = '#00BFFF';
        ctx.beginPath();
        ctx.arc(x, y, 4, 0, Math.PI * 2);
        ctx.fill();
        
        // Glow effect
        ctx.shadowBlur = 10;
        ctx.shadowColor = '#00BFFF';
        ctx.fill();
        ctx.shadowBlur = 0;
      });
    }
  }, [data]);

  return (
    <div className={styles.graphContainer}>
      <canvas ref={canvasRef} width={200} height={120} className={styles.graph}></canvas>
      {label && <p className={styles.graphLabel}>{label}</p>}
    </div>
  );
};

export default GraphVisual;

